import SystemStatus from '../SystemState'

// used for route access
export const UserUnauthorized = () => (
  <SystemStatus>
    <p>Du har ej behörighet till sidan du försöker öppna</p>
  </SystemStatus>
)
